import * as React from 'react';

import {
  Breadcrumb,
  BreadcrumbEllipsis,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from './components/ui/breadcrumb.js';

export function DimeBreadcrumb({ ...props }: Readonly<React.ComponentProps<typeof Breadcrumb>>) {
  return <Breadcrumb {...props} />;
}

export function DimeBreadcrumbList({
  ...props
}: Readonly<React.ComponentProps<typeof BreadcrumbList>>) {
  return <BreadcrumbList {...props} />;
}

export function DimeBreadcrumbItem({
  ...props
}: Readonly<React.ComponentProps<typeof BreadcrumbItem>>) {
  return <BreadcrumbItem {...props} />;
}

export function DimeBreadcrumbLink({
  ...props
}: Readonly<React.ComponentProps<typeof BreadcrumbLink>>) {
  return <BreadcrumbLink {...props} />;
}

export function DimeBreadcrumbPage({
  ...props
}: Readonly<React.ComponentProps<typeof BreadcrumbPage>>) {
  return <BreadcrumbPage {...props} />;
}

export function DimeBreadcrumbSeparator({
  ...props
}: Readonly<React.ComponentProps<typeof BreadcrumbSeparator>>) {
  return <BreadcrumbSeparator {...props} />;
}

export function DimeBreadcrumbEllipsis({
  ...props
}: Readonly<React.ComponentProps<typeof BreadcrumbEllipsis>>) {
  return <BreadcrumbEllipsis {...props} />;
}
